module.exports = __webpack_public_path__ + "static/media/HART1330W.0020d5ab.pdf";